/** Friendly labels for AlertEventType values from the API. */
const EVENT_TYPE_LABELS: Record<string, string> = {
  PriceChange: 'Price Change',
  EnrollmentDateChange: 'Enrollment Date Change',
  EnrollmentDuplicates: 'Enrollment Duplicates',
  CaseExternalMessage: 'Case External Message',
  PortalUserChange: 'Portal User Change',
  EnrollmentPeriodUpcoming: 'Enrollment Period Upcoming',
  '0': 'Price Change',
  '1': 'Enrollment Date Change',
  '2': 'Enrollment Duplicates',
  '3': 'Case External Message',
  '4': 'Portal User Change',
  '5': 'Enrollment Period Upcoming'
};

const EVENT_TYPE_TONES: Record<string, string> = {
  PriceChange: 'price-change',
  EnrollmentDateChange: 'enrollment-date-change',
  EnrollmentDuplicates: 'enrollment-duplicates',
  CaseExternalMessage: 'case-external-message',
  PortalUserChange: 'portal-user-change',
  EnrollmentPeriodUpcoming: 'enrollment-period-upcoming',
  '0': 'price-change',
  '1': 'enrollment-date-change',
  '2': 'enrollment-duplicates',
  '3': 'case-external-message',
  '4': 'portal-user-change',
  '5': 'enrollment-period-upcoming'
};

const ENROLLMENT_DUPLICATES_KEYS = new Set([
  'EnrollmentDuplicates',
  '2',
  'Enrollment Duplicates'
]);

/** True when a stored alert is an enrollment-duplicates notification. The live count belongs on the dashboard only. */
export function isEnrollmentDuplicatesAlert(raw?: string | number | null): boolean {
  if (raw === null || raw === undefined || raw === '') {
    return false;
  }

  return ENROLLMENT_DUPLICATES_KEYS.has(String(raw).trim());
}

/**
 * Normalize API eventType/category (string or numeric enum) into a readable label.
 */
export function formatAlertEventType(raw?: string | number | null): string {
  if (raw === null || raw === undefined || raw === '') {
    return '';
  }

  const key = String(raw).trim();
  if (EVENT_TYPE_LABELS[key]) {
    return EVENT_TYPE_LABELS[key];
  }

  return key
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/_/g, ' ')
    .trim();
}

/**
 * CSS tone key for event-type badges (e.g. "price-change").
 */
export function alertEventTypeTone(raw?: string | number | null): string {
  if (raw === null || raw === undefined || raw === '') {
    return 'default';
  }

  const key = String(raw).trim();
  if (EVENT_TYPE_TONES[key]) {
    return EVENT_TYPE_TONES[key];
  }

  const normalized = key
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/[_\s]+/g, '-')
    .toLowerCase();

  return normalized || 'default';
}
